import { render, staticRenderFns } from "./SiteLock.vue?vue&type=template&id=33f70b52"
import script from "./SiteLock.vue?vue&type=script&lang=js"
export * from "./SiteLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports